<template>
  <VcitaSelectDropDown
    prepend-inner-icon="icon-Map-marker"
    class="location-selector"
    :value="value"
    v-bind="$attrs"
    @input="handleInput"
    :label="value ? $t('booking.info.where_question_mark') : ''"
    :placeholder="!value ? $t('booking.info.where_question_mark') : ''"
    :menuProps="{contentClass: 'location-selection-menu-content'}"
    :items="items">
    <template v-slot:item="{item, attrs, on}">
      <v-list-item

        v-bind="attrs"
        v-on="on"
        class="location-item"
      >
        <v-list-item-title>
          <v-icon class="location-icon">{{item.icon}}</v-icon>
          <span class="location-text">
            {{item.text}}
          </span>

        </v-list-item-title>
      </v-list-item>
    </template>
  </VcitaSelectDropDown>
</template>

<script>
  import VcitaSelectDropDown from "@/modules/common/components/VcitaSelectDropDown/VcitaSelectDropDown.vue"

  export default {
    name: "locationSelector",
    components: {
      VcitaSelectDropDown
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      excludes: {
        type: Array,
        default: () => []
      }
    },
    data() {
     let items = [
       {
         header: this.$t('settings.service_page.service_location.face_to_face'),
       },
       {
         text: this.$t('settings.service_page.service_location.sub_type.location.default_business'),
         icon: 'icon-Office-location',
         value: 'business_location',
       },
       {
         text: this.$t('appointment.info.interaction_types.client_location.short_type'),
         icon: 'icon-User-location',
         value: 'client_location',
       },
       {
         header: this.$t('event.info.interaction_types.online.type'),
       },
     ]
      if(this.$hasFeature('zoom_vcita')) {
        items.push({
          text: this.$t('appointment.info.interaction_types.zoom.type'),
          icon: 'icon-Zoom',
          value: 'zoom',
        })
      }
      items = [
        ...items,
        {
        text: this.$t('booking.info.interaction_types.skype.type'),
        icon: 'icon-Skype',
        value: 'skype',
        },
        {
          text: this.$t('settings.service_page.service_location.online'),
          icon: 'icon-Online',
          value: 'online',
        },
        {
          header: this.$t('settings.service_page.service_location.phone'),
        },
        {
          text: this.$t('settings.service_page.service_location.sub_type.phone.business'),
          icon: 'icon-Incoming-call',
          value: 'business_phone',
        },
        {
          text: this.$t('settings.service_page.service_location.sub_type.phone.client'),
          icon: 'icon-Outcoming-call',
          value: 'client_phone',
        }]

      if (this.excludes.length > 0) {
        items = this.excludesFilter(items);
      }

     return {
      items,
     }
    },
    updated() {
      if(this.value === 'default_business_location') {
        this.$emit('input', 'business_location')
      }
    },
    mounted() {
      if(this.value === 'default_business_location') {
        this.$emit('input', 'business_location')
      }
    },
    methods: {
      handleInput(val) {
        this.$emit('input', val)
      },
      excludesFilter(items) {
        return  items.filter(item => !this.excludes.includes(item.value));
      }
    },
  };
</script>


<style lang="scss" scoped>

  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

    .location-item {
      max-height: 40px;
      min-height: 40px;
    }
    .location-icon {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.4);
      @include i-margin-mirror(0, 12px);
    }
    .location-text {
      font-size: 13px;
      font-weight: 500;
      line-height: 1.85;
      letter-spacing: -0.2px;
    }
</style>

<style lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";
  .location-selection-menu-content {
    font-family: var(--primary-font-family);
    @include md-and-up {
      max-width: 412px;
    }
  }
</style>
